import React, { useState } from 'react';
import {
  ShoppingCart,
  Phone,
  Mail,
  MapPin,
  Video,
  CheckCircle2,
  ChevronRight,
  Menu,
  X,
  ArrowRight,
  Play,
} from 'lucide-react';

// Ikona TikTok jako komponent SVG
const TikTokIcon = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
  </svg>
);

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const mainShopUrl = "https://sklephadron.pl/brand/322-zz2-eu-unipessoal-lda";
  const ytChannelUrl = "https://www.youtube.com/@SklepHADRON";
  const blogUrl = "https://sklephadron.pl/blog/";
  const fbUrl = "https://www.facebook.com/SklepHadron/";
  const tiktokUrl = "https://www.tiktok.com/@sklephadron?lang=pl-PL";

  const contactPhone = "22 663 47 58";
  const contactEmail = "info@sklephadron.pl";
  const officeAddress = "ul. Krasińskiego 59 lokal 74, 01-755 Warszawa";

  const categories = [
    {
      id: 1,
      title: "Dedykowane ekrany",
      description: "Nowoczesne wyświetlacze z funkcjami Android Auto i CarPlay, zastępujące fabryczne jednostki w desce rozdzielczej.",
      image: "/images/Dedykowane_Ekrany_multimedialne_ZZ2.jpg",
      link: "https://sklephadron.pl/2413-ekrany-z-android-auto-i-carplay-"
    },
    {
      id: 2,
      title: "Moduły Android Auto / CarPlay",
      description: "Dodaj bezprzewodową łączność Android Auto i CarPlay do swojego oryginalnego radia bez wymiany fabrycznego ekranu.",
      image: "/images/Moduly_ZZ2_Android-Auto_CarPlay.jpg",
      link: "https://sklephadron.pl/2448-dedykowane-doposazenie"
    },
    {
      id: 3,
      title: "Moduły kamer cofania",
      description: "Interfejsy umożliwiające podłączenie kamer cofania i kamer najazdu do fabrycznych monitorów samochodowych.",
      image: "/images/Moduly_ZZ2_kamer_cofania.jpg",
      link: "https://sklephadron.pl/86-do-kamer-cofania"
    },
    {
      id: 4,
      title: "Ekrany motocyklowe",
      description: "Wodoodporne i wstrząsoodporne ekrany z obsługą Android Auto i CarPlay dedykowane dla motocyklistów.",
      image: "/images/ZZ2_Nawigacja_AndroidAuro_CarPlay-do_motoru.jpg",
      link: "https://sklephadron.pl/2453-nawigacja-motocyklowa"
    }
  ];

  const zz2Videos = [
    {
      id: "dCzz2OzQH98",
      title: "ZZ2 - Najlepszy CarPlay i Android Auto?",
      thumbnail: "https://img.youtube.com/vi/dCzz2OzQH98/maxresdefault.jpg"
    },
    {
      id: "F6dxLn6AXPI",
      title: "Bezprzewodowy CarPlay w Twoim aucie dzięki ZZ2",
      thumbnail: "https://img.youtube.com/vi/F6dxLn6AXPI/maxresdefault.jpg"
    }
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white font-sans selection:bg-yellow-400 selection:text-black scroll-smooth">

      {/* Navigation */}
      <nav className="fixed w-full z-50 bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <span className="text-3xl font-black tracking-tighter text-yellow-400 uppercase italic">ZZ2</span>
              <div className="h-6 w-px bg-white/20 mx-3"></div>
              <a href={blogUrl} target="_blank" rel="noopener noreferrer" className="text-sm font-bold tracking-widest text-gray-400 hover:text-white transition-colors uppercase">
                HADRON
              </a>
            </div>

            <div className="hidden md:flex items-center space-x-8">
              <a href="#kategorie" className="text-sm font-medium hover:text-yellow-400 transition-colors uppercase tracking-wider">Kategorie</a>
              <a href="#technologia" className="text-sm font-medium hover:text-yellow-400 transition-colors uppercase tracking-wider">Technologia</a>
              <a href="#video" className="text-sm font-medium hover:text-yellow-400 transition-colors uppercase tracking-wider">Recenzje</a>
              <a href="#kontakt" className="text-sm font-medium hover:text-yellow-400 transition-colors uppercase tracking-wider">Kontakt</a>
              <a
                href={mainShopUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-yellow-400 text-black px-6 py-2.5 rounded-full font-black text-sm flex items-center gap-2 hover:bg-yellow-300 transition-all transform hover:scale-105 shadow-lg shadow-yellow-400/20 uppercase tracking-tight"
              >
                <ShoppingCart size={18} />
                Sklep Online
              </a>
            </div>

            <button className="md:hidden text-white" onClick={() => setIsMenuOpen(!isMenuOpen)}>
              {isMenuOpen ? <X /> : <Menu />}
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full pointer-events-none opacity-20">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[1000px] h-[1000px] bg-yellow-400 rounded-full blur-[150px]"></div>
        </div>

        <div className="max-w-7xl mx-auto px-4 relative z-10 text-center">
          <div className="inline-block px-4 py-1.5 bg-yellow-400/10 border border-yellow-400/20 rounded-full text-yellow-400 text-xs font-bold tracking-widest uppercase mb-6">
            Oficjalny Partner ZZ2 w Polsce
          </div>
          <h1 className="text-5xl md:text-8xl font-black mb-8 tracking-tighter leading-[0.9] uppercase italic text-white">
            Twoje auto, <span className="text-yellow-400">nowoczesne</span> multimedia.
          </h1>
          <p className="text-xl md:text-2xl text-gray-400 max-w-3xl mx-auto mb-10 leading-relaxed font-medium">
            Bezprzewodowy <span className="text-white">Android Auto</span> i <span className="text-white">CarPlay</span> w Twoim fabrycznym systemie. Jakość bez kompromisów.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <a href={mainShopUrl} target="_blank" rel="noopener noreferrer" className="bg-yellow-400 text-black px-10 py-5 rounded-full font-black text-lg hover:bg-yellow-300 transition-all flex items-center justify-center gap-2 group shadow-2xl shadow-yellow-400/20 uppercase">
              Sprawdź ofertę w sklepie
              <ArrowRight className="group-hover:translate-x-1 transition-transform" />
            </a>
            <a href="#technologia" className="bg-white/5 border border-white/10 hover:bg-white/10 text-white px-10 py-5 rounded-full font-bold text-lg transition-all flex items-center justify-center uppercase">
              Poznaj technologię
            </a>
          </div>
        </div>
      </section>

      {/* Categories Grid */}
      <section id="kategorie" className="py-24 max-w-7xl mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <div className="max-w-2xl">
            <h2 className="text-5xl font-black mb-4 tracking-tight uppercase italic text-white">Rozwiązania ZZ2</h2>
            <p className="text-gray-400 text-lg">Wybierz kategorię i dowiedz się, jak unowocześnić swój pojazd.</p>
          </div>
          <div className="hidden md:block">
            <a href={mainShopUrl} target="_blank" rel="noopener noreferrer" className="text-yellow-400 font-bold flex items-center gap-2 hover:translate-x-2 transition-transform uppercase text-sm tracking-widest">
              Wszystkie produkty <ChevronRight size={24} />
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.link}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative bg-[#151515] rounded-[2rem] overflow-hidden border border-white/5 hover:border-yellow-400/50 transition-all flex flex-col h-full hover:shadow-2xl hover:shadow-yellow-400/10"
            >
              <div className="h-72 overflow-hidden relative bg-black">
                <img
                  src={cat.image}
                  alt={cat.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 opacity-90 group-hover:opacity-100"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#151515] via-transparent to-transparent opacity-40"></div>
              </div>
              <div className="p-8 flex flex-col flex-grow relative -mt-4 bg-[#151515] rounded-t-[2rem]">
                <h3 className="text-2xl font-black mb-4 group-hover:text-yellow-400 transition-colors uppercase tracking-tight leading-none italic text-white">{cat.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-8 flex-grow">
                  {cat.description}
                </p>
                <div className="flex items-center text-yellow-400 font-bold gap-2 group-hover:gap-4 transition-all uppercase text-xs tracking-widest border-t border-white/5 pt-6">
                  Sprawdź w sklepie <ArrowRight size={16} />
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>

      {/* Technology Section */}
      <section id="technologia" className="py-24 bg-white/[0.02]">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-black mb-16 uppercase italic text-white tracking-tighter">Integracja bez kompromisów</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
            {[
              { t: "Plug & Play", d: "Instalacja nie wymaga cięcia kabli ani niszczenia deski rozdzielczej. Wszystko opiera się na fabrycznych wtyczkach." },
              { t: "Oryginalne sterowanie", d: "Używaj pokrętła iDrive, MMI czy przycisków na kierownicy tak samo, jak w fabrycznym systemie." },
              { t: "Dźwięk Hi-Fi", d: "Systemy ZZ2 wykorzystują fabryczny tor audio, gwarantując najwyższą jakość muzyki i rozmów." }
            ].map((item, i) => (
              <div key={i} className="p-8 bg-black/40 rounded-3xl border border-white/5 group hover:border-yellow-400/30 transition-all">
                <div className="w-16 h-16 bg-yellow-400/10 text-yellow-400 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <CheckCircle2 size={32} />
                </div>
                <h4 className="text-xl font-black mb-4 uppercase italic text-white">{item.t}</h4>
                <p className="text-gray-400 text-sm leading-relaxed">{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section id="video" className="py-24 max-w-7xl mx-auto px-4">
        <div className="flex justify-between items-center mb-12">
          <h2 className="text-4xl font-black italic uppercase text-white tracking-tighter">Recenzje <span className="text-red-600">YouTube</span></h2>
          <a href={ytChannelUrl} target="_blank" rel="noopener noreferrer" className="bg-red-600 text-white px-8 py-3 rounded-full font-black uppercase text-sm flex items-center gap-2 hover:bg-red-700 transition-all shadow-lg shadow-red-600/10">
            <Video /> Hadron TV
          </a>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {zz2Videos.map(v => (
            <div key={v.id} className="group relative rounded-[2rem] overflow-hidden border border-white/10 aspect-video bg-black shadow-2xl">
              <img src={v.thumbnail} alt={v.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute inset-0 flex items-center justify-center">
                <a href={`https://www.youtube.com/watch?v=${v.id}`} target="_blank" rel="noopener noreferrer" className="w-20 h-20 bg-red-600 rounded-full flex items-center justify-center text-white transform group-hover:scale-110 transition-transform shadow-2xl shadow-red-600/20">
                  <Play size={40} fill="white" />
                </a>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8 bg-gradient-to-t from-black to-transparent">
                <p className="text-lg font-bold text-white uppercase italic tracking-tight">{v.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Trust & Contact Section */}
      <section id="kontakt" className="py-24 max-w-7xl mx-auto px-4">
        <div className="bg-yellow-400 rounded-[3rem] p-8 md:p-16 text-black relative overflow-hidden shadow-2xl shadow-yellow-400/20">
          <div className="relative z-10 flex flex-col lg:flex-row gap-16 items-start">
            <div className="lg:w-1/2">
              <h2 className="text-5xl md:text-6xl font-black mb-8 tracking-tighter leading-none uppercase italic">Masz pytania?<br/><span className="text-black/60 font-black tracking-tighter">Pomożemy Ci wybrać.</span></h2>
              <p className="text-xl font-bold mb-12 max-w-md italic opacity-80">Nasi handlowcy – Marcin i Daniel – doradzą Ci najlepszy system ZZ2 do Twojego auta.</p>
              <div className="space-y-4">
                <a href={`tel:+48${contactPhone.replace(/\s/g, '')}`} className="flex items-center gap-6 p-6 bg-black text-white rounded-2xl hover:scale-102 transition-transform group shadow-xl">
                  <div className="bg-yellow-400 text-black p-4 rounded-xl group-hover:rotate-12 transition-transform"><Phone size={28} /></div>
                  <div><p className="text-xs font-bold uppercase opacity-60">Zadzwoń teraz</p><p className="text-2xl font-black tracking-tight">+48 {contactPhone}</p></div>
                </a>
                <a href={`mailto:${contactEmail}`} className="flex items-center gap-6 p-6 bg-black/5 rounded-2xl hover:bg-black/10 transition-colors group border border-black/10">
                  <div className="bg-black text-yellow-400 p-4 rounded-xl"><Mail size={28} /></div>
                  <div><p className="text-xs font-bold uppercase opacity-60">Napisz e-mail</p><p className="text-2xl font-black tracking-tight">{contactEmail}</p></div>
                </a>
              </div>
            </div>
            <div className="lg:w-1/2 w-full bg-black/5 p-12 rounded-[2.5rem] border border-black/10 backdrop-blur-sm">
              <h4 className="font-black text-2xl mb-6 flex items-center gap-2 uppercase tracking-tighter italic"><MapPin size={32} /> Zapraszamy stacjonarnie</h4>
              <p className="text-2xl font-black mb-1 uppercase">Warszawa</p>
              <p className="text-lg font-bold mb-8 opacity-80 leading-tight italic">{officeAddress}</p>
              <div className="flex justify-between items-center py-3 border-b border-black/10 mb-10">
                <span className="font-bold text-sm uppercase opacity-70 italic">Poniedziałek - Piątek</span>
                <span className="font-black text-xl">9:00 - 17:00</span>
              </div>
              <a href="https://www.google.com/maps/search/?api=1&query=Hadron+Krasińskiego+59+Warszawa" target="_blank" rel="noopener noreferrer" className="block text-center w-full py-5 bg-black text-white rounded-xl font-black text-lg hover:opacity-90 transition-all uppercase italic tracking-wider shadow-2xl">Wyznacz trasę</a>
            </div>
          </div>
        </div>
      </section>

      {/* Footer Socials */}
      <footer className="py-20 border-t border-white/5 text-center text-gray-500">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex justify-center items-center gap-2 mb-12">
            <span className="text-3xl font-black tracking-tighter text-white uppercase italic">ZZ2</span>
            <div className="h-6 w-px bg-white/20 mx-2"></div>
            <span className="text-sm font-bold tracking-widest uppercase italic">Projekt Hadron</span>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-6 md:gap-10 mb-16 uppercase font-black text-[10px] tracking-widest">
             <a href={ytChannelUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-red-600 transition-all"><Video size={20} /> YouTube</a>
             <a href={fbUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-blue-600 transition-all">📘 Facebook</a>
             <a href={tiktokUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-cyan-400 transition-all"><TikTokIcon size={20} /> TikTok</a>
             <div className="h-4 w-px bg-white/10 hidden md:block"></div>
             <a href={blogUrl} target="_blank" rel="noopener noreferrer" className="hover:text-yellow-400 transition-colors italic tracking-[0.2em]">Blog Hadron</a>
          </div>

          <p className="text-[10px] uppercase tracking-[0.2em] font-bold opacity-20 italic">© 2024 HADRON Paweł Ślubowski | Wszystkie prawa zastrzeżone</p>
        </div>
      </footer>
    </div>
  );
};

export default App;
